import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { appPaths } from "../../shared/routing/appPaths";
import { useProjects } from "../../projects/projectContext";
import MemoryCatalogue from "./MemoryCatalogue";

/**
 * `/profile/memories`: the signed-in person's memories in the chosen project, what they kept
 * and what their agents saved for them (memory.md MEM-7, WA-8). Every memory is its owner's
 * alone (J-01 (a)); here they manage them, deleting included.
 */
export default function MyMemoriesPage() {
  const { t } = useTranslation();
  const projects = useProjects();
  const projectId = projects.selectedProjectId;
  const projectName = projects.selectedProject?.status === "loaded" ? projects.selectedProject.value.project.name : null;

  return (
    <div className="w-full max-w-3xl space-y-4">
      <header className="space-y-1">
        <h1 className="app-title text-xl font-semibold">{t("memories.mine.title")}</h1>
        <p className="app-text-muted max-w-prose text-sm">
          {projectName === null ? t("memories.mine.explanation") : t("memories.mine.explanationInProject", { project: projectName })}
        </p>
      </header>
      {projectId === null ? (
        <Link to={appPaths.projects()} className="app-link text-sm underline">{t("projects.needed.title")}</Link>
      ) : (
        <MemoryCatalogue key={projectId} projectId={projectId} />
      )}
    </div>
  );
}
